var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Loader from '../Loader';
import { ButtonStyled, ButtonChildrenStyled } from './styled';
const Button = (_a) => {
    var { children, onClick } = _a, props = __rest(_a, ["children", "onClick"]);
    const { disabled, loading, startAdornment, endAdornment, variant, contentStyle } = props, rest = __rest(props, ["disabled", "loading", "startAdornment", "endAdornment", "variant", "contentStyle"]);
    const loaderColor = variant === 'inverted' ? '#FFF' : null;
    const loaderComponent = _jsx(Loader, { size: 16, color: loaderColor });
    return (_jsxs(ButtonStyled, Object.assign({}, rest, { variant: variant, disabled: disabled || loading, onClick: onClick }, { children: [_jsxs(ButtonChildrenStyled, Object.assign({ style: contentStyle, endAdornment: endAdornment }, { children: [startAdornment && loading ? loaderComponent : startAdornment, !startAdornment && loading ? loaderComponent : children] })), !loading && endAdornment] })));
};
Button.defaultProps = {
    loading: false,
    disabled: false,
};
export default Button;
//# sourceMappingURL=index.js.map